import { createBrowserHistory } from 'history';

const history = createBrowserHistory({ basename: '/admin' });

export default history;
